export enum PaymentStatusEnum {
  Succeeded = 'Succeeded',
  FAILD = 'FAILD'
}
